import React, { Dispatch, SetStateAction, FC } from "react";
import Choices from "../../Choices";
import { sliderPocket } from "./defaults";
import { styled } from "@mui/material/styles";
import usePocketSelector from "./usePocketSelector";

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

interface SliderPocketProps {
  setSliderConfig: Dispatch<SetStateAction<string>>;
}

const SliderPocket: FC<SliderPocketProps> = ({ setSliderConfig }) => {
  const { handleClick, sliderP } = usePocketSelector(setSliderConfig);

  return (
    <StyledDiv>
      {sliderPocket.map((item) => (
        <div key={item.id} onClick={() => handleClick(item.label)}>
          <Choices
            label={item.label}
            variant={item.label === sliderP ? "filled" : "outlined"}
            checkMark={item.label === sliderP}
          />
        </div>
      ))}
    </StyledDiv>
  );
};

export default SliderPocket;
